<script lang="ts" setup>
import { ref, useAttrs, watch } from 'vue';

const attrs = useAttrs();
const inputValue = ref(null);
const telInputTef = ref();
const emits = defineEmits(['update:modelValue']);

// 初始化数据
watch(
  () => attrs.modelValue,
  (newValue: any, oldValue: any) => {
    inputValue.value = newValue;
  },
  {
    immediate: true,
    deep: true,
  },
);

watch(
  () => inputValue,
  (newValue: any, oldValue: any) => {
    // Trim spaces from phone number before emitting
    const trimmedValue = newValue.value ? newValue.value.replace(/\s+/g, '') : newValue.value;
    emits('update:modelValue', trimmedValue);
  },
  {
    immediate: true,
    deep: true,
  },
);
</script>

<template>
  <vue-tel-input
    ref="telInputTef"
    v-model="inputValue"
    :show-dial-code="true"
    mode="international"
    :enabledFlags="true"
  ></vue-tel-input>
</template>

<style lang="scss">
.vue-tel-input {
  width: 100%;
  border-radius: 10px !important;
  padding: 2px;
  font-family: 'Barlow';
  border: 1px solid #9d9d9f !important;
  background-color: var(--el-input-bg-color, var(--el-fill-color-blank));
  background-image: none;
  position: relative;
  &:focus-within {
    box-shadow: 0 0 0 1px rgb(82, 89, 157) inset !important;
  }
  // &:focus {
  //   box-shadow: 0 0 0 1px var(--el-input-focus-border-color) inset;
  // }
  .div-input-class {
    width: 100%;
  }
  .vti__dropdown {
    width: 70px;
    font-size: 20px !important;
  }
  .vti__input {
    width: 100% !important;
    height: 48px;
    text-align: right;
    padding: 0 8px;
    margin: 0 5px;
    font-size: 20px !important;
  }
  .vti__dropdown {
    position: fixed !important;
    z-index: 999 !important;
    margin-left: 5px;
  }
  .vti__dropdown-list {
    top: 50px !important;
    width: 400px !important;
    z-index: 999 !important;
    font-size: 20px !important;
    scrollbar-width: none; // Firefox
    -ms-overflow-style: none; // old Edge/IE
    &::-webkit-scrollbar {
      display: none; // Chrome/Safari/new Edge
    }
    .vti__dropdown-item {
      font-size: 20px !important;
      .vti__dropdown-item-label {
        font-size: 20px !important;
      }
    }
  }
}
</style>
